__webpack_require__.p = "https://veda.astrology.com/";